<div 
    *ngIf="loading===false" class="z-20 fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75"
    (click)="$event.preventDefault(); handleCloseTeam();"
>
    <div class="max-h-screen w-full flex flex-col items-center justify-center overflow-hidden">
        <div class="w-full max-w-screen-md flex my-6 p-8 gap-8 bg-white rounded-md shadow-lg overflow-hidden" (click)="$event.stopPropagation()">
            <div class="w-full flex flex-col overflow-hidden">
                <div class="flex items-center justify-center gap-2 p-2 border-s-4 border-nside-orange-400 bg-orange-50 rounded-r-md">
                    <div class="w-8 h-8">
                        <button 
                            class="w-8 h-8 flex items-center justify-center rounded-full bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 text-white shadow-custom-2"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-lightbulb">
                                <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
                                <path d="M9 18h6" />
                                <path d="M10 22h4" />
                            </svg>
                        </button>
                    </div>
                    <p class="text-xs">Select the users you would like to review this case. It is recommended that at least three other people be selected to review at every stage. While multiple users can be assigned to review, only one is required to approve the stage for the case to progress.</p>
                </div>
                <h2 class="pt-4 text-center oswald-font text-3xl mb-2">REQUEST A REVIEW</h2>
                <h2 class="text-center text-lg mb-4">for case {{ caseId }}</h2>
                <div class="flex-grow flex flex-wrap items-center justify-center gap-2 overflow-y-auto">
                    <ng-container *ngIf="threatAssessmentTeam.length > 0; else emptythreatAssessmentTeam">            
                        <div *ngFor="let member of threatAssessmentTeam" class="flex items-center gap-2 mb-2">
                            <button
                                class="h-10 px-2.5 py-1.5 flex items-center justify-between rounded-md hover:text-white hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200"
                                [ngClass]="{
                                    'text-white bg-gradient-to-b from-nside-orange-100 to-nside-orange-200': isMembersSelected(member),
                                    'bg-gray-50': !isMembersSelected(member)
                                    }"
                                (click)="$event.preventDefault(); addMemberToRequest(member);"
                            >
                                {{ member.name }}
                            </button>
                        </div>
                    </ng-container>
                    <ng-template #emptythreatAssessmentTeam>
                        <div class="text-center text-nside-gray-100 italic">
                            Threat Assessment Team must be fulfilled.
                        </div>
                    </ng-template>
                </div>
                <div class="w-full my-2 flex items-end justify-between oswald-font">
                    <!-- <button
                        class="px-4 py-1.5 rounded-md border border-nside-gray-400"
                        (click)="$event.preventDefault(); this.selectedMembers=null;"
                    >
                        Clear All
                    </button> -->
                    <div class="h-full w-full flex items-end justify-end gap-2">
                        <button
                            class="py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                            (click)="$event.preventDefault(); handleCloseTeam();"
                        >
                            Close
                        </button>
                        <button 
                            [disabled]="selectedMembers === null || selectedMembers.length === 0"
                            class="w-20 h-full flex items-center justify-center rounded-md border bg-gradient-to-b oswald-font text-white"
                            [ngClass]="{
                                'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': selectedMembers === null || selectedMembers.length === 0,
                                'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': selectedMembers !== null && selectedMembers.length > 0
                            }"
                            (click)="$event.preventDefault(); handleSendRequest();"
                        >
                            Request
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="loading">
    <spinner></spinner>
</div>